function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t\t.st0-finish{fill:none;stroke:#000000;stroke-width:26;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_11"
}, /*#__PURE__*/React.createElement("path", {
  d: "M327.36,247.21l-122.7-70.6c-7.61-4.38-17.1,1.12-17.08,9.9l0.21,141.56c0.01,8.78,9.52,14.25,17.11,9.85l122.49-70.96 C334.98,262.56,334.97,251.59,327.36,247.21l-122.7-70.6c-7.61-4.38-17.1,1.12-17.08,9.9l0.21,141.56 c0.01,8.78,9.52,14.25,17.11,9.85l122.49-70.96C334.98,262.56,334.97,251.59,327.36,247.21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.7,383.99c0-3.48,0.17-6.92,0.51-10.31H66.27V128.24h365.92V293.8c14.56,8.24,26.92,19.9,36,33.89V77.16 c0-25.15-20.46-45.62-45.62-45.62H75.88c-25.15,0-45.62,20.46-45.62,45.62v346.69c0,25.15,20.46,45.62,45.62,45.62h246.88 C295.55,450.8,277.7,419.48,277.7,383.99z M413.68,67.54h8.89c5.3,0,9.62,4.31,9.62,9.62v15.09h-18.51V67.54z M355.68,67.54h22 v24.7h-22V67.54z M297.68,67.54h22v24.7h-22V67.54z M239.68,67.54h22v24.7h-22V67.54z M181.68,67.54h22v24.7h-22V67.54z  M123.68,67.54h22v24.7h-22V67.54z M66.27,77.16c0-5.3,4.31-9.62,9.62-9.62h11.8v24.7H66.27V77.16z M87.68,433.46h-11.8 c-5.3,0-9.62-4.31-9.62-9.62v-14.16h21.42V433.46z M145.68,433.46h-22v-23.78h22V433.46z M203.68,433.46h-22v-23.78h22V433.46z  M261.68,433.46h-22v-23.78h22V433.46z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0-finish",
  d: "M314.85,402.86l16.9,27.84c2.48,4.09,8.58,3.54,10.3-0.92l32.3-84.04"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0-finish",
  d: "M382.49,402.86l16.9,27.84c2.48,4.09,8.58,3.54,10.3-0.92l32.3-84.04"
}));

var SvgFinish = function SvgFinish(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFinish, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/finish.f06ce280.svg";
export { ForwardRef as ReactComponent };